<template>
    <div class="slideVerification_tips" >
        <div class="slideVerification_tips_bg">
			<div class="box" id="box">
				<div class="tit">拖动下方滑块完成拼图</div>
				<div class="image" @click="shua()" id="checkImg" :style="{backgroundImage:'url('+image+')'}">
					<div id="div1"></div>
					<div id="div2" :style="{backgroundImage:'url('+imageDebris+')'}"></div>
				</div>
				<div class="drag">
					<div id="hk" @mousemove="hua" @mousedown="check" @mouseup="checked"></div>
					<div></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    data() {
	return {
        animating: false,//滑块是否处于滑动状态
	    offsetX: 0,
	    x: 280,
	    y: 100,
        image: require('../assets/slideImg.png'),//背景大图
	    imageDebris: require('../assets/slideImgAct.png'),//小拼图块图片
		keepBef: 10,
		currentDian:0,
        }
    },
    methods: {
    hua(e) {
		if (!this.animating)
			return
		var div2 = document.getElementById('div2')
		let domDiv = div2.getBoundingClientRect().left
		var hk = document.getElementById('hk')
		let moveRange = e.pageX - this.currentDian
		this.offsetX = moveRange + 10 >300 ? 300 : moveRange + 10 <0 ? 0 : 
		// div2.style.left = this.offsetX + 'px'
		// hk.style.left = this.offsetX + 'px'

						div2.style.left =  moveRange + 10  + 'px'
				hk.style.left =  moveRange + 10  + 'px'
		// }
		// else{
		// 	// if(moveRange > 0 && moveRange < 300){
		// 		div2.style.left =  this.offsetX + moveRange  + 'px'
		// 		hk.style.left =  this.offsetX + moveRange  + 'px'
		// 	// }
		// }
		this.keepBef = e.pageX



	
		// if (domDiv.left - this.offsetX < 300 && domDiv.left - this.offsetX > 0){
		// 	div2.style.left = domDiv.left - this.offsetX + 10 + 'px'
		// 	hk.style.left = domDiv.left - this.offsetX - 10 + 'px'
		// }
		
	},
	check(e) {
		this.currentDian = e.pageX
		this.animating = true
	},
	checked() {
		var div2 = document.getElementById('div2')
		var hk = document.getElementById('hk')
		this.animating = false
		let num = this.offsetX - 574 > 0? this.offsetX - 574 : 0
		if (num >= this.x - 10 && num <= this.x + 10) {
			alert('验证成功！')
		} else {
			div2.style.left = '10px'
			hk.style.left = '0px'
		}
	},
	shua() {
		// var checkImg = document.getElementById('checkImg')
		// var div1 = document.getElementById('div1')
		// var div2 = document.getElementById('div2')
		// var hk = document.getElementById('hk')
		// this.animating = false
		// this.offsetX = 0

		// this.x = parseInt(Math.random() * 250 + 150)
		// this.y = parseInt(Math.random() * 120)

		// this.image = slideImg//修改背景大图图片
		// this.imageDebris= slideImgAct//修改小拼图块图片
		// div1.style.cssText = 'left:' + this.x + 'px;top:' + this.y + 'px'
		// div2.style.cssText = 'background-position: -' + this.x + 'px -' + this.y + 'px;top:' + this.y + 'px'
		// hk.style.left = this.offsetX + 'px'
	},
    }
}
</script>

<style scoped lang="scss">
    .slideVerification_tips{
        width: 100%;
        height: 100%;
        /*background: red;*/
        position:fixed;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
		flex-direction: column;
        z-index: 999;

    .slideVerification_tips_bg{
        width: 100%;
        height: 100%;
        /*background: red;*/
        position:absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.2);
    }
	.tit{
		font-size: 20px;
		font-family: PingFangSC, PingFang SC;
		color: #333333;
		line-height: 28px;
		margin: 20px 0;
		text-align: center;
	}
	}
.box {
	// width: 450px;
	// height: 200px;
	margin: 20px 0 20px 300px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
	background-color: #fff;
	padding: 0 25px 80px;
	border-radius: 10px;
	.image {
		position: relative;
		width: 360px;
		height: 220px;
		background-size: 100% 100%;

		div:nth-child(1) {
			position: absolute;
			top: 72px;
  			left: 270px;
			width: 40px;
			height: 40px;
		}

		div:nth-child(2) {
			position: absolute;
			top: 78px;
			left: 10px;
			width: 75px;
			height: 88px;
			background-size: 100%;
			// background-position: -280px -100px;
		}
	}

	.drag {
	    height: 30px;
		font-size: 0;
		margin-top: 10px;
			position: relative;

		div:nth-child(1) {
			display: inline-block;
			position: relative;
			height: 48px;
			width: 95px;
			vertical-align: top;
			background-repeat: no-repeat;
			background-position: center;
			background-size: 100%;
			background-image: url('../assets/button_huadong@2x.png');
		}

		div:nth-child(2) {
			position: absolute;
			top: 13px;
			z-index: -1;
			height: 20px;
			width: 350px;
			margin-left: 5px;
			line-height: 30px;
			background-color: #E6E6E6;
			pointer-events: none;
			border-radius: 15px;

		}
	}
}
</style>